import { useQuery } from "@tanstack/react-query";
import Axios from "../../../lib/axios";
import { TResponse } from "../../../types/common";

export const useDashboardStats = () => {
  return useQuery({
    queryKey: ["dashboard", "stats"],
    queryFn: async () => {
      const res = await Axios.get<TResponse<any>>("/dashboard/stats");
      return res.data;
    },
    refetchInterval: 60000, // Auto refresh every 60 seconds
  });
};
